export const SURVICATE_ID =
  process.env.NODE_ENV === 'production' ? '03075305d2238cb9' : '1f64ee2e34cec04a';

export const AVATAR_DIMENSIONS = '76x76';
